<template>
  <modal
    ref="SuppliesConfirmationModal"
    title="Pedido realizado com sucesso!"
    template="confirmation"
    ref-name="SuppliesConfirmationModal"
    class="supplies-confirmation-modal"
    :hide-second-button="true"
    @first-cta="closeModal()"
  >
    <div class="supplies-confirmation-modal__content">
      <p>
        Seu pedido foi enviado para avaliação e será analisado de acordo com a sua média trimestral e volume atual
        enviado para nossos NTOS.
      </p>
      <p class="supplies-confirmation-modal__id">
        O número do seu pédido é: <b>{{ id }}</b>
      </p>
    </div>
  </modal>
</template>
<script>
export default {
  name: 'CollectionPointCreateModal',
  data: () => ({
    id: null
  }),
  methods: {
    closeModal() {
      this.$refs.SuppliesConfirmationModal.close()
      this.$router.push('/gestao-de-insumos')
    },
    openModal(id) {
      this.id = id
      this.$refs.SuppliesConfirmationModal.open()
    }
  }
}
</script>

<style lang="scss" scoped>
  .supplies-confirmation-modal {
    &__content {
      p {
        font-size: 16px;
        text-align: center;
        line-height: 19px;
        color: #5a5a5a;
        max-width: 510px;
      }
    }
    &__id {
      margin: 20px 0 0 !important;

      b {
        color: #7f1a54;
      }
    }
  }
</style>
